module.exports = __webpack_public_path__ + "static/media/finance-re-gnv2.c5c66b95.svg";